import React from 'react';
import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    Stack,
} from '@mui/material';
import { useIntl } from 'react-intl';
import {
    ENABLED_FILTER_ALL,
    ENABLED_FILTER_DISABLED,
    ENABLED_FILTER_ENABLED,
    STATUS_FILTER_LABEL_IDS,
    STATUS_FILTER_OPTIONS,
} from './allSourcesFilterUtils';

const ENABLED_OPTIONS = [
    ENABLED_FILTER_ALL,
    ENABLED_FILTER_ENABLED,
    ENABLED_FILTER_DISABLED,
];

const ENABLED_LABEL_IDS = {
    [ENABLED_FILTER_ALL]: 'monitoring.allSources.filter.enabled.all',
    [ENABLED_FILTER_ENABLED]: 'monitoring.allSources.filter.enabled.enabled',
    [ENABLED_FILTER_DISABLED]: 'monitoring.allSources.filter.enabled.disabled',
};

export default function AllSourcesFilters({
    enabledFilter,
    onEnabledFilterChange,
    selectedStatuses,
    onSelectedStatusesChange,
}) {
    const intl = useIntl();

    const enabledTitle = intl.formatMessage({
        id: 'monitoring.allSources.filter.enabled.title',
    });
    const statusTitle = intl.formatMessage({
        id: 'monitoring.allSources.filter.status.title',
    });
    const statusAllLabel = intl.formatMessage({
        id: 'monitoring.allSources.filter.status.all',
    });

    const formatStatusLabel = (status) =>
        intl.formatMessage({ id: STATUS_FILTER_LABEL_IDS[status] });

    return (
        <Stack
            direction="row"
            spacing={1.5}
            useFlexGap
            flexWrap="wrap"
            justifyContent="flex-end"
            sx={{ flexShrink: 0 }}
        >
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel shrink id="all-sources-enabled-filter-label">
                    {enabledTitle}
                </InputLabel>
                <Select
                    labelId="all-sources-enabled-filter-label"
                    data-testid="all-sources-enabled-filter"
                    value={enabledFilter}
                    label={enabledTitle}
                    onChange={(event) => onEnabledFilterChange(event.target.value)}
                >
                    {ENABLED_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                            {intl.formatMessage({ id: ENABLED_LABEL_IDS[option] })}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 180 }}>
                <InputLabel shrink id="all-sources-status-filter-label">
                    {statusTitle}
                </InputLabel>
                <Select
                    labelId="all-sources-status-filter-label"
                    data-testid="all-sources-status-filter"
                    multiple
                    displayEmpty
                    value={selectedStatuses}
                    label={statusTitle}
                    onChange={(event) => {
                        const { value } = event.target;
                        onSelectedStatusesChange(
                            typeof value === 'string' ? value.split(',') : value
                        );
                    }}
                    renderValue={(selected) => {
                        if (!selected.length) {
                            return statusAllLabel;
                        }
                        return selected.map((status) => formatStatusLabel(status)).join(', ');
                    }}
                >
                    {STATUS_FILTER_OPTIONS.map((status) => (
                        <MenuItem key={status} value={status}>
                            <Checkbox checked={selectedStatuses.includes(status)} size="small" />
                            <ListItemText primary={formatStatusLabel(status)} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
}
